import { Response } from '@marketplace-web/shared/api-client'

import { transformProfileUserInfoDto } from './profile-user-info'
import { ProfileUserInfoDto } from '../types/dtos/profile-user-info'

export const transformProfileUserInfoResponse = (response: Response<ProfileUserInfoDto>) =>
  transformProfileUserInfoDto(response)
